// extracted by mini-css-extract-plugin
export default {"btn":"MenuBtn_btn__SD0r9","shake-animation":"MenuBtn_shake-animation__D0nmt","count":"MenuBtn_count__ZHdTh"};